import { Button } from "react-bootstrap";

const TypesHeader = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  total,
  onAddType,
  canManage,
}) => {
  return (
    <div className="card-header d-flex justify-content-between align-items-center">
      <h4 className="card-title mb-0">Types ({total})</h4>
      <div className="d-flex gap-2 align-items-center">
        <select
          className="form-select w-auto"
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
        >
          <option value="">All statuses</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search types"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <Button type="button" onClick={onAddType} disabled={!canManage}>
          + Create Type
        </Button>
      </div>
    </div>
  );
};

export default TypesHeader;
